import { render, staticRenderFns } from "./MainIndex.vue?vue&type=template&id=071fe58d&scoped=true&"
import script from "./MainIndex.vue?vue&type=script&lang=js&"
export * from "./MainIndex.vue?vue&type=script&lang=js&"
import style0 from "./MainIndex.vue?vue&type=style&index=0&id=071fe58d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071fe58d",
  null
  
)

export default component.exports